// Swiper
import Swiper from "swiper";
import { Navigation, Scrollbar, Mousewheel, Pagination, Autoplay, FreeMode, Manipulation } from 'swiper/modules';
// Swiper.use([Navigation, Scrollbar, Mousewheel, Pagination, Autoplay]);
import loadStylesheet from "../loadStylesheet";

// carousel options based on carousel type.
import * as options from "./options";
import lazyElements from "../lazyElements/lazyElements";
import lazyImages from "../lazyImages/lazyImages";

export default class Carousel {
    /**
     * @param {Element} carousel - html DOM element.
     * @param {boolean} lazy - Load the carousel only when it comes into the viewport?
     * @param {boolean}
     * @param {object}
     * @param {function}
     */
    constructor(carousel, lazy = false, showCarouselOnMobile = true, customOptions = null, lazyCallback = null) {
        /**
         * If carousel shouln't be shown on mobile add
         * window.matchmedia object to detect window size.
         */
        // this.breakpoint = !showCarouselOnMobile ? window.matchMedia("(min-width:768px)") : null;

        this.el = carousel;
        this.swiperWrapper = this.el.querySelector(".il-no-m-swipper");
        this.lazy = lazy;
        this.swiper = null;
        this.customOptions = customOptions;
        this.options = null;
        this.intersectionalObservers = [];
        this.lazyCallback = lazyCallback;

        if (!showCarouselOnMobile) {
            if (!this.el.classList.contains("swiper-container"))
                this.el.classList.add("swiper-container");
        }

        this.init();
        // if (showCarouselOnMobile) {
        // } else {
        // this.breakpointChecker();
        // this.breakpoint.addEventListener('change', this.breakpointChecker);
        // }

    }

    init = () => {
        // if (!!!window.il_stylesheetLoaded && window.innerWidth >= 768) {
        //     this.el.onmouseover = loadStylesheet;
        // }
        if (!this.lazy) {
            this.intializeCarousel();
            return;
        }

        this.intersectionalObservers.push(lazyElements(this.el, this.intializeCarousel));
    };

    // breakpointChecker = () => {
    //     if (this.breakpoint.matches) {
    //         if (!this.el.classList.contains("swiper-container"))
    //             this.el.classList.add("swiper-container");

    //         if (!this.swiperWrapper.classList.contains("swiper-wrapper")) {
    //             this.swiperWrapper.classList.add("swiper-wrapper");
    //         }

    //         this.init();
    //     } else {
    //         if (this.swiper !== null)
    //             this.swiper.destroy(true, true);

    //         if (this.el.classList.contains("swiper-container"))
    //             this.el.classList.remove("swiper-container");

    //         if (this.swiperWrapper.classList.contains("swiper-wrapper"))
    //             this.swiperWrapper.classList.remove("swiper-wrapper");
    //     }
    // };

    getImgUrlParameter() {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('img')) {
            return urlParams.get('img');
        } else {
            return null;
        }
    }

    intializeCarousel = () => {
        let options = this.options || this.getCarouselOptions();

        if (!this.swiper) {
            this.swiper = new Swiper(this.el, {
                ...options,
                modules: [FreeMode, Navigation, Scrollbar, Mousewheel, Pagination, Autoplay, Manipulation],
                on: {
                    init: this.swiperOninit,
                }
            });

            if (this.el.classList.contains("il-location-carousel")) {
                var imgId = this.getImgUrlParameter();
                if (imgId) {
                    let slide = document.querySelector('img[data-id="' + imgId +'"]');
                    if(!!slide.dataset.imageIndex){
                        this.swiper.slideTo(slide.dataset.imageIndex);
                    };
                } else {
                    console.log('No img parameter found.');
                }
            }
        }

        setTimeout(() => {
            loadStylesheet();
        }, 1000);
    };

    swiperOninit = () => {
        // Lazy Images
        let carouselImgs = this.el.querySelectorAll("img.carousel-lazy-img");
        this.intersectionalObservers.push(lazyImages(carouselImgs));

        if (this.lazyCallback) this.lazyCallback();

        const event = new Event('carouselInitilized');
        this.el.dispatchEvent(event);
    };

    getCarouselOptions() {
        // set carousel options.
        let carouselOptions = options._default;

        if (this.el.classList.contains("il-large-carousel")) {
            carouselOptions = Object.assign(carouselOptions, options.largeCarousel);
        }

        if (this.el.classList.contains("il-location-carousel")) {
            carouselOptions = Object.assign(carouselOptions, options.locationCarousel);
        }

        if (this.el.classList.contains("il-similar-locations-carousel")) {
            Object.assign(carouselOptions, options.similarLocations);
        }
        if (this.el.classList.contains("tears-carousel")) {
            Object.assign(carouselOptions, options.tearCarousel);
        }

        if (!!this.customOptions) {
            carouselOptions = {
                ...carouselOptions,
                ...this.customOptions,
            }
        }

        return this.options = carouselOptions;
    }
}
